// We have to use old versions of these packages because the new versions are not compatible with our unified version/pipeline.
// Code is inspired by https://github.com/remarkjs/remark-gfm/blob/1.0.0/index.js
// Make sure you're looking at version 0.1.6 of mdast-util-gfm-table and 0.4.3 of micromark-extension-gfm-table

// @ts-expect-error: No types available for this version of 'mdast-util-gfm-table'
import {fromMarkdown, toMarkdown} from 'mdast-util-gfm-table';
// @ts-expect-error: No types available for this version of 'micromark-extension-gfm-table'
import * as gfmTableExtension from 'micromark-extension-gfm-table';
import type {Plugin} from 'unified';

export const remarkGfmTables: Plugin = function () {
  const data = this.data();
  const tableExtension = gfmTableExtension.default || gfmTableExtension;

  add('micromarkExtensions', tableExtension);
  add('fromMarkdownExtensions', fromMarkdown);
  add('toMarkdownExtensions', toMarkdown);

  function add(field: string, value: unknown): void {
    // oxlint-disable-next-line no-cond-assign
    const list = data[field] ? data[field] : (data[field] = []);
    (list as Array<unknown>).push(value);
  }
};
